import { Component, type ErrorInfo, type ReactNode } from 'react'

/**
 * Contain rendering errors (e.g. one malformed item from an agent) to the smallest area
 * instead of blanking the whole app on both phones.
 */
export class ErrorBoundary extends Component<{ children: ReactNode; label?: string; fallback?: ReactNode }, { error: Error | null }> {
  override state: { error: Error | null } = { error: null }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(`[terrazzo] ${this.props.label ?? 'view'} crashed`, error, info.componentStack)
  }

  override render() {
    if (!this.state.error) return this.props.children
    if (this.props.fallback !== undefined) return this.props.fallback
    return (
      <div className="rounded-xl border border-dashed border-line-2 px-3 py-2 text-xs text-muted" role="alert">
        Couldn’t show {this.props.label ?? 'this part'}.{' '}
        <button type="button" className="underline" onClick={() => this.setState({ error: null })}>
          Retry
        </button>
      </div>
    )
  }
}
